import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class TerraceGardens9PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.TERRACE_GARDENS9;
}

export default TerraceGardens9PoiTileEntity;
